import { useState } from 'react';
import { useBanking, useUpdateBanking } from '../../hooks/useBanking.js';
import { useError } from '../shared/ErrorBanner.jsx';

export default function BankingPanel() {
  const { data: b } = useBanking();
  const [editing, setEditing] = useState(false);

  return (
    <div className="panel">
      <h3 className="panel-title">
        <span><i className="ph ph-bank" /> Direct deposit</span>
        <button className="btn-sm" onClick={() => setEditing(e => !e)}>
          {editing ? 'Cancel' : (b?.bank_account_last4 ? 'Update' : '+ Add')}
        </button>
      </h3>
      {editing ? (
        <BankingFormBody initial={b} onDone={() => setEditing(false)} />
      ) : (
        <div style={{
          fontFamily: 'var(--font-label)', fontSize: 12,
          color: 'var(--on-surface-variant)',
          textTransform: 'uppercase', letterSpacing: '0.06rem',
        }}>
          {b?.bank_account_last4 ? (
            <>
              <div>Routing: {b.bank_routing?.slice(0, 4)}…{b.bank_routing?.slice(-2)}</div>
              <div style={{ marginTop: 6 }}>
                Account: ••••{b.bank_account_last4} ({b.bank_account_type})
              </div>
            </>
          ) : (
            <div style={{ color: 'var(--warm-gray)' }}>
              No bank account on file. Without it, you'll be paid by check or CSV-uploaded ACH.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function BankingFormBody({ initial, onDone }) {
  const [routing, setRouting] = useState(initial?.bank_routing || '');
  const [account, setAccount] = useState('');
  const [confirm, setConfirm] = useState('');
  const [type, setType] = useState(initial?.bank_account_type || 'checking');
  const update = useUpdateBanking();
  const { show } = useError();

  const submit = async (e) => {
    e.preventDefault();
    if (account !== confirm) { show("Account numbers don't match"); return; }
    try {
      await update.mutateAsync({ routing, account, account_type: type });
      onDone();
    } catch (err) { show(err.message); }
  };

  return (
    <form onSubmit={submit}>
      <div className="field">
        <label className="field-label">Routing (9 digits)</label>
        <input className="field-input" value={routing} onChange={e => setRouting(e.target.value)}
          inputMode="numeric" autoComplete="off" required />
      </div>
      <div className="field">
        <label className="field-label">Account number</label>
        <input className="field-input" value={account} onChange={e => setAccount(e.target.value)}
          inputMode="numeric" autoComplete="off" required />
      </div>
      <div className="field">
        <label className="field-label">Confirm account</label>
        <input className="field-input" value={confirm} onChange={e => setConfirm(e.target.value)}
          inputMode="numeric" autoComplete="off" required />
      </div>
      <div className="field">
        <label className="field-label">Account type</label>
        <select className="field-select" value={type} onChange={e => setType(e.target.value)}>
          <option value="checking">Checking</option>
          <option value="savings">Savings</option>
        </select>
      </div>
      <button className="btn-sm primary" type="submit" disabled={update.isPending}>
        {update.isPending ? 'Saving…' : 'Save'}
      </button>
    </form>
  );
}
